"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _solarReact = require("@solar/solar-react");

var _Lock = _interopRequireDefault(require("@material-ui/icons/Lock"));

var _styles = require("@material-ui/core/styles");

var _useProductData = require("../useProductData");

var _useParsedJson7 = _interopRequireDefault(require("./useParsedJson"));

var _CustomJsonForms = _interopRequireDefault(require("../CustomJsonForms"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {// width: '100%',
      // flexGrow: 1,
      // alignItems: 'stretch',
    }
  };
});

var FormPreview = function FormPreview(_ref) {
  var formJSON = _ref.formJSON,
      formUIJSON = _ref.formUIJSON,
      formData = _ref.formData,
      onChangeFormData = _ref.onChangeFormData,
      selectedType = _ref.selectedType,
      classes = _ref.classes;
  var c = useStyles({
    classes: classes
  }); // current selectedType can be invalid JSON

  var _useParsedJson = (0, _useParsedJson7["default"])(formJSON[selectedType]),
      _useParsedJson2 = _slicedToArray(_useParsedJson, 2),
      parsedSchema = _useParsedJson2[0],
      validSchema = _useParsedJson2[1];

  var _useParsedJson3 = (0, _useParsedJson7["default"])(formUIJSON[selectedType]),
      _useParsedJson4 = _slicedToArray(_useParsedJson3, 2),
      parsedUISchema = _useParsedJson4[0],
      validUISchema = _useParsedJson4[1];

  var _useParsedJson5 = (0, _useParsedJson7["default"])(formData[selectedType]),
      _useParsedJson6 = _slicedToArray(_useParsedJson5, 2),
      parsedData = _useParsedJson6[0],
      validData = _useParsedJson6[1];

  var parsed = (0, _useProductData.nullable)((0, _useProductData.useProductData)({
    formJSON: (0, _deepmerge["default"])(formJSON, _defineProperty({}, selectedType, parsedSchema)),
    formUIJSON: (0, _deepmerge["default"])(formUIJSON, _defineProperty({}, selectedType, parsedUISchema)),
    formData: (0, _deepmerge["default"])(formData, _defineProperty({}, selectedType, parsedData))
  }, selectedType));
  var allValid = validSchema && validUISchema && validData;
  var noSchema = !parsed.formJSON && !parsed.formData;
  var map = {
    formJSON: 'schema',
    formUIJSON: 'uischema',
    formData: 'data'
  };
  var props = Object.keys(map).reduce(function (memo, prop) {
    if (!parsed[prop]) {
      return memo;
    }

    return _objectSpread(_objectSpread({}, memo), {}, _defineProperty({}, map[prop], parsed[prop]));
  }, {});
  return /*#__PURE__*/_react["default"].createElement(_solarReact.ScrollableContent, {
    className: c.root
  }, noSchema && /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
    Icon: _Lock["default"],
    label: "no schema provided"
  }), !noSchema && /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    fullColumn: true
  }, !allValid && /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
    Icon: _Lock["default"],
    label: "not all data is valid JSON"
  }), /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveSheet, {
    maxWidth: 1024
  }, /*#__PURE__*/_react["default"].createElement(_CustomJsonForms["default"], _extends({}, props, {
    onChange: function onChange(_ref2) {// console.log(errors, data);
      // onChangeFormData(JSON.stringify(data, null, 2));

      var errors = _ref2.errors,
          data = _ref2.data;
    }
  })))));
};

var _default = FormPreview;
exports["default"] = _default;